module.exports = __webpack_public_path__ + "static/media/bg_4.0ac50c08.png";